<template>
  <div>
    <CCard>
      <CCardHeader>
        <CIcon name="cil-grid" />Seri Tryout
        <div class="card-header-actions">
          <CLink href="#" class="card-header-action btn-setting">
            <a @click="addMapping">
              <CIcon name="cil-plus" />
            </a>
          </CLink>
        </div>
      </CCardHeader>
      <CCardBody>
        <div style="overflow: inherit">
          <table class="table table-bordered table-stripped">
            <thead>
              <tr>
                <th>Seri</th>
                <th>Jalur Masuk</th>
                <th>Group</th>
                <th>Durasi</th>
                <th>Periode</th>
                <th>Harga</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(d, k) in items" :key="k">
                <td>
                  {{ d.label }}
                  <CBadge color="danger" v-show="d.deleted_at">Dihapus</CBadge>
                </td>
                <td>
                  <label v-for="(vm, km) in d.entrance_majors" :key="km" :class="`entrance-major-label ${vm.label}`">
                    {{vm.label}}
                  </label>
                </td>
                <td>
                  <span v-if="d.study_program_group && d.study_program_group.name">{{d.study_program_group.name}}</span>
                  <span v-if="!(d.study_program_group && d.study_program_group.name)">-</span>
                </td>
                <td align="center">{{ d.duration }}</td>
                <td align="center">
                  <strong>{{ d.effective_date | dateFormat }}</strong> sd.
                  <strong>{{ d.effective_until | dateFormat }}</strong>
                </td>
                <td align="right">{{ d.price | thousandSeparator }}</td>
                <td class="action">
                  <btn-edit @click="doEdit(d.id)" />
                  <btn-delete @click="doDelete(d.id)" v-show="!d.deleted_at" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </CCardBody>
      <CCardFooter>
        <content-pagination-2 :paginator="paginate" @change="getList" />
      </CCardFooter>
    </CCard>
  </div>
</template>
<script>
import BtnEdit from "../../components/BtnEdit";
import BtnDelete from "../../components/BtnDelete";
import { HTTPAUTH } from "../../lib/httplib";
import ContentPagination2 from "../../components/ContentPagination2.vue";
export default {
  components: {
    BtnEdit,
    BtnDelete,
    ContentPagination2,
  },
  data() {
    return {
      items: [],
      paginate: {},
    };
  },
  created() {
    this.getList(1);
  },
  methods: {
    getList(page) {
      HTTPAUTH.get(`/api/v1/admin/series?size=10&page=${page}`).then((res) => {
        this.items = res.data.data;
        this.paginate = res.data.paginate;
      });
    },
    addMapping() {
      this.$router.push({ path: "/soal/mapping/new" });
    },
    doEdit(id) {
      this.$router.push({ path: "/soal/mapping/" + id });
    },
    doDelete(id) {
      HTTPAUTH.delete(`/api/v1/admin/series/${id}`).then(() => {
        this.getList(1);
      });
    },
  },
};
</script>